var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UiButton", {
        attrs: {
          buttonText: "Download clients data",
          variant: "white",
          processing: _vm.loading,
          disabled: _vm.loading,
          size: "lg",
        },
        on: { click: _vm.handleDownload },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [_c("DownloadIcon", { staticClass: "w-4 h-4" })]
            },
            proxy: true,
          },
          {
            key: "hover-icon",
            fn: function () {
              return [_c("DownloadIcon", { staticClass: "w-4 h-4" })]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }